import { Result, ok, err } from "neverthrow";
import { ParseError } from "../../shared/errors/parseError";
import { INoticeInfoParser, HttpNoticeInfo } from "../bbsRepository.types";
import { INoticeInfoData, NoticeInfo } from "@/domain/entities/bbs";
import dayjs from "dayjs";
import { injectable } from "inversify";
import { insertAltTextToImageTag } from "@/utils/insertAltTextToImageTag";

@injectable()
export class NoticeInfoParser implements INoticeInfoParser {
  constructor() {}

  toDomain(data: HttpNoticeInfo): Result<INoticeInfoData, ParseError> {
    try {
      const noticeInfoData: INoticeInfoData = {
        id: data.uid,
        category: data.popupYn ? "알림" : "공지",
        title: data.title,
        content: insertAltTextToImageTag(data.bodyText, data.altText ?? ""),
        createdDate: data.createdTs
          ? dayjs(data.createdTs).format("YYYY-MM-DD")
          : "",
        lastModifiedDate: data.savedTs
          ? dayjs(data.savedTs).format("YYYY-MM-DD")
          : "",
        isShow: data.displayYn,
        isPopup: data.popupYn,
        campusCodeUid: data.campusCode,
        campusName: data.campusName,
        altText: data.altText,
        wasRead: data.readYn,
      };
      const noticeInfo = new NoticeInfo(noticeInfoData);
      return ok(noticeInfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
